import { PiCheckSquare } from 'react-icons/pi'
import { RxCross2 } from 'react-icons/rx'
import { apolloClient } from '~/common/apollo-client'
import { useMarkAllNotificationsAsReadMutation } from '~/common/generated/apollo-operations'
import { useTypedTranslation } from '~/common/hooks/useTypedTranslation'

type NotificationHeaderProps = {
  onClose: () => void
}

export function NotificationHeader({ onClose }: NotificationHeaderProps) {
  const { t } = useTypedTranslation()
  const [markAllAsRead, { loading }] = useMarkAllNotificationsAsReadMutation({
    onCompleted: () => {
      apolloClient.cache.evict({ fieldName: 'paginatedNotifications' })
      apolloClient.cache.gc()
    },
  })

  return (
    <div className="flex items-center justify-between border-b border-gray-4 px-6 py-5">
      <div className="text-sm">{t('notification_header.notifications')}</div>
      <div className="flex items-center gap-4">
        <div
          className="inline-flex cursor-pointer items-center gap-2 text-xs text-gray-9 hover:text-gray-11"
          onClick={() => {
            if (!loading) {
              markAllAsRead()
            }
          }}
        >
          {t('notification_header.mark_all_as_read')}
          <PiCheckSquare size={16} />
        </div>
        <button
          className="flex size-6 shrink-0 items-center justify-center rounded-full text-gray-10 hover:bg-gray-3"
          onClick={onClose}
        >
          <RxCross2 size={16} />
        </button>
      </div>
    </div>
  )
}
